export const SET_ACTIVE_USER = 'SET_ACTIVE_USER';